import type { GetStaticProps } from "next";
import Blog from "~/components/blog";
import Metadata from "~/components/metadata";
import client from "~/config/client";
import type Nullable from "~/types/nullable";
import type { PostCoreDataFragment, PostsQuery } from "~/__generated__/graphql";
import { getSdk } from "~/__generated__/graphql";

type Props = {
  posts: PostsQuery["posts"];
  highlight?: Nullable<PostCoreDataFragment>;
};

export const getStaticProps: GetStaticProps<Props> = async () => {
  const highlight = await getHighlight();
  const { posts } = await getSdk(client).Posts({
    pagination: {
      limit: 6,
    },
    sort: "publishedAt:desc",
    filters: {
      ...(highlight?.id && {
        id: {
          not: {
            in: [highlight.id],
          },
        },
      }),
    },
  });

  return {
    revalidate: 1,
    props: {
      posts,
      highlight,
    },
  };
};

export default function BlogPage(props: Props) {
  return (
    <>
      <Metadata
        pageTitle="Advante Blog"
        title="Learn more about coaching"
        description="For insights on coaching and leadership to better understand the role they play and the impact they have on your teams success."
        canonical="https://advante.co/blog"
      />
      <Blog {...props} />
    </>
  );
}

async function getHighlight() {
  const { posts } = await getSdk(client).Posts({
    sort: ["views:desc", "publishedAt:desc"],
    pagination: {
      limit: 1,
    },
  });

  return posts?.data.at(0) ?? null;
}
